<template>
  <div class="bespread-wrap module-layer3">
    <div class="screen-container role-active">
      <swiper
        :options="roleOptions"
        ref="roleOptions"
        @slideChange="roleNavSlideChange"
        class="ani"
        swiper-animate-effect="fadeInRight"
        swiper-animate-duration="0.5s"
        swiper-animate-delay="0.1s"
      >
        <swiper-slide v-for="(iconItem, idx) in roleList" :key="idx">
          <div class="role " :class="'role-' + iconItem.id">
            <img
              :src="
                require('../../assets/img/layer3/role-' +
                  (idx + 1) +
                  '/role-' +
                  lang +
                  '.png')
              "
              alt=""
              srcset=""
              class="role-info _role-remark"
            />
            <img
              src="../../assets/img/layer3/audio-btn.png"
              alt=""
              srcset=""
              class="audio-btn cursor _role-remark"
              :class="'role-' + iconItem.id + '-aduio'"
              @click="handleAudio(iconItem)"
            />
            <img
              :src="iconItem.roleIdx"
              alt=""
              srcset=""
              class="roleIdx _role-remark"
            />
            <img :src="iconItem.bgIdx" alt="" srcset="" class="bgIdx" />
          </div>
        </swiper-slide>
      </swiper>
      <div
        class="swiper-pagination swiper-pagination-role cursor ani"
        swiper-animate-effect="fadeInLeft"
        swiper-animate-duration="0.5s"
        swiper-animate-delay="0.1s"
        :class="[nextShow ? '' : 'swiperNoSwiping']"
        slot="pagination"
      ></div>
    </div>

    <!-- audio -->
    <audio
      controls="controls"
      ref="audio"
      id="nameAttrValue"
      style="display: none;"
    >
      <source :src="musicUrl" type="audio/wav" />
    </audio>
  </div>
</template>
<script>
export default {
  name: "app",
  props: ["language"],

  data() {
    let myMusic = this.$refs.myMusic;
    return {
      musicUrl: "", // 音频地址
      lang: localStorage.getItem("sof_locale") || "en",
      iconActive: 1,
      roleList: [
        {
          id: 1,
          // info: require("../../assets/img/layer3/1-msg.png"),
          roleIdx: require("../../assets/img/layer3/1-role.png"),
          bgIdx: require("../../assets/img/layer3/1-bg.png"),
          audioSrc: require("../../assets/img/layer3/audio/1-audio.wav")
        },
        {
          id: 2,
          // info: require("../../assets/img/layer3/2-msg.png"),
          roleIdx: require("../../assets/img/layer3/2-role.png"),
          bgIdx: require("../../assets/img/layer3/2-bg.png"),
          audioSrc: require("../../assets/img/layer3/audio/2-audio.wav")
        },
        {
          id: 3,
          // info: require("../../assets/img/layer3/3-msg.png"),
          roleIdx: require("../../assets/img/layer3/3-role.png"),
          bgIdx: require("../../assets/img/layer3/3-bg.png"),
          audioSrc: require("../../assets/img/layer3/audio/3-audio.wav")
        },
        {
          id: 4,
          // info: require("../../assets/img/layer3/4-msg.png"),
          roleIdx: require("../../assets/img/layer3/4-role.png"),
          bgIdx: require("../../assets/img/layer3/4-bg.png"),
          audioSrc: require("../../assets/img/layer3/audio/4-audio.wav")
        },
        {
          id: 5,
          // info: require("../../assets/img/layer3/5-msg.png"),
          roleIdx: require("../../assets/img/layer3/5-role.png"),
          bgIdx: require("../../assets/img/layer3/5-bg.png"),
          audioSrc: require("../../assets/img/layer3/audio/5-audio.wav")
        }
      ],
      nextShow: true,
      roleOptions: {
        effect: "fade",
        fadeEffect: {
          crossFade: true
        },
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination-role",
          touchRatio: 1, //解决滑动卡顿
          longSwipesRatio: 0.1,
          threshold: 10, //如果触摸距离小于该值滑块不会被拖动
          followFinger: false,
          bulletClass: "my-bullet", //需设置.my-bullet样式
          clickable: true, // 允许点击小圆点跳转
          autoplayDisableOnInteraction: false,

          renderBullet: function(index, className) {
            switch (index) {
              case 0:
                name = "";
                break;
              case 1:
                name = "";
                break;
              case 2:
                name = "";
              case 3:
                name = "";
              default:
                name = "";
            }
            return (
              '<div class="' +
              className +
              " " +
              className +
              [index] +
              '"><i>' +
              name +
              "</i></div>"
            );
          }
        }
      }
    };
  },
  watch: {
    // 监听到父组件传递过来的数据后，加工一下，
    // 存到data中去，然后在页面上使用
    language(newVal, oldVal) {
      this.lang = newVal;
    }
  },
  methods: {
    roleNavSlideChange() {},
    handleAudio(val) {
      this.$refs.audio.src = val.audioSrc;
      let audio = this.$refs.audio;
      audio.load();
      audio.play();
    },
    // 滑动箭头的时候，音频不播放
    stopAduio() {
      let audio = this.$refs.audio;
      audio.pause();
    },
    roleNavSlideChange() {
      this.stopAduio();
    }
  }
};
</script>
<style lang="scss">
.module-layer3 {
  // pointer-events: none;

  .screen-container {
    background-image: url("../../assets/img/layer3/bg.png");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    // 菜单
    .swiper-slide {
      overflow: hidden;
    }

    .role {
      position: relative;
      width: 100%;
      height: 100%;

      .audio-btn {
        width: 164px;
        height: 52px;
        position: absolute;
        left: 18%;
        top: 31.5vw;
        z-index: 2;
      }
      .role-info {
        width: auto;
        height: 632px;
        position: absolute;
        left: 18%;
        top: 8vw;
        // transform: translate(0, -50%);
      }
    }
    // 每个角色尺寸大小需单独设置
    .role .bgIdx {
      width: 1920px;
      height: 2460px;
      display: block;
      position: absolute;
      right: 0;
      top: -354px;
      opacity: 0.5;
    }
    .role .roleIdx {
      z-index: 1;
    }
    .role-1 .roleIdx {
      width: 1825px;
      height: 1502px;
      position: absolute;
      right: -27%;
      top: 2vw;
    }
    .role-2 .roleIdx {
      width: 1920px;
      height: 1709px;
      //   width: 883px;
      // height: 1135px;
      position: absolute;
      right: -23%;
      top: -3vw;
    }
    .role-3 .roleIdx {
      width: 1920px;
      height: 1641px;
      position: absolute;
      right: -20%;
      top: -3.2vw;
    }
    .role-4 .roleIdx {
      width: 1485px;
      height: 1843px;

      position: absolute;
      right: -18%;
      top: 1.5vw;
    }
    .role-5 .roleIdx {
      width: 1028px;
      height: 1172px;

      position: absolute;
      right: -5%;
      top: 0vw;
    }
    // 头像icon
    .swiper-pagination-role {
      transition: all 0.5s;
      z-index: 3;
      top: 8vw;
      left: 6%;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      gap: 0.5vw;

      .my-bullet {
        // display: flex;
        // justify-content: center;
        width: 123px;
        height: 123px;
        filter: grayscale(100%);
        i {
          display: block;
          width: 100%;
          height: 100%;
          z-index: 1;
        }
      }
      .swiper-pagination-bullet-active {
        background-color: transparent;
        filter: grayscale(0);
      }
      .my-bullet0 i {
        background: url("../../assets/img/layer3/1.png") no-repeat;
        background-size: 100% 100%;
      }

      .my-bullet1 i {
        background: url("../../assets/img/layer3/2.png") no-repeat;
        background-size: 100% 100%;
      }

      .my-bullet2 i {
        background: url("../../assets/img/layer3/3.png") no-repeat;
        background-size: 100% 100%;
      }

      .my-bullet3 i {
        background: url("../../assets/img/layer3/4.png") no-repeat;
        background-size: 100% 100%;
      }

      .my-bullet4 i {
        background: url("../../assets/img/layer3/5.png") no-repeat;
        background-size: 100% 100%;
      }
    }
  }

  .role-active .swiper-slide-active ._role-remark {
    animation: _fadeInRight 0.6s both;
    opacity: 0;
  }
  // .role-active ._pagination {
  //   animation: _fadeInLeft 0.6s both;
  //   opacity: 0;
  // }
  // @keyframes _fadeInLeft {
  //   0% {
  //     opacity: 0;
  //     transform: translate3d(-15vw, 0, 0);
  //   }

  //   to {
  //     opacity: 1;
  //     transform: translateZ(0);
  //   }
  // }

  @keyframes _fadeInRight {
    0% {
      opacity: 0;
      transform: translate3d(20vw, 0, 0);
    }

    to {
      opacity: 1;
      transform: translateZ(0);
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer3 {
   .swiper-pagination-role,
   .role-info  {
    top: 12vw !important;
   }
   .role-1 .roleIdx{
    top: 4vw !important;
   }
   .role-2 .roleIdx,
   .role-3 .roleIdx{
    top: -1vw !important;
   }
    .role-5 .roleIdx{
      top: 4vw !important;
      right: -1% !important;
    }
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer3 {
     .swiper-pagination-role,
   .role-info  {
    top: 10vw !important;
   }
      .role-1 .roleIdx{
    top: 4vw !important;
   }
   .role-2 .roleIdx,
   .role-3 .roleIdx{
    top: -1vw !important;
   }
    .role-5 .roleIdx{
      top: 3vw !important;
      right: -1% !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer3.vue